import { login as loginApi, logout as logoutApi,getUserInfo, getAliyunImgPrefix } from '@/api/user'
import { examManageLogin } from '@/api/examManage'

import {setToken,removeToken } from '@/utils/auth'

const state = {
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
}

const mutations = {
  // 保存用户信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  // 清除用户信息
  CLEAR_USER_INFO(state) {
    state.token = ''
    state.userInfo = {}
    removeToken()
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // 登录
  async login({ commit }, userData) {
    const res = await loginApi(userData)
    const imgPrefix = await getAliyunImgPrefix()
    localStorage.setItem('imgPrefix', imgPrefix.msg)
    // return res
    if (res.token) {
      setToken(res.token)
    }
    return res
  },
  // 登录
  async login2({ commit }, userData) {
    const res = await examManageLogin(userData)
    const imgPrefix = await getAliyunImgPrefix()
    localStorage.setItem('imgPrefix', imgPrefix.msg)
    // return res
    if (res.token) {
      setToken(res.token)
    }
    return res
  },
  // 退出登录
  async logout({ commit }) {
    try {
      await logoutApi()
    } catch (error) {
      console.log('退出登录接口调用失败', error)
    } finally {
      commit('CLEAR_USER_INFO')
    }
  },
  // 获取用户信息
  async getInfo({ commit }, pValue) {
    const res = await getUserInfo(pValue)
    commit('SET_USER_INFO', res)
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
